<template>
    <div class="md-custom-code ai-img2code" v-if="html" :style="{ marginBottom, minHeight }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <renderHtml
                class="custom-code-html-content"
                :innerHTML="html"
            />
        </module-box>
    </div>
</template>

<script>

import util from '@/common/util';
import { renderHtml } from '@/common/utils/decode-html';

export default {
    components: {
        renderHtml
    },
    data: function() {
        return {
            imgCode: {
                "html": "",
                "img": ""
            },
            isClient: util.isClient
        };
    },
    computed: {
        html({ imgCode }) {
            if (!imgCode || !imgCode.html) {
                return '';
            }
            if (!imgCode.html.endsWith(' ')) {
                return imgCode.html + ' ';
            }
            return imgCode.html
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        minHeight() {
            if (util.inCmsPageEditor) {
                return '80px';
            }
            return null;
        }
    }
};

</script>

<style lang="scss">
.md-custom-code.ai-img2code{
    p, h1, h2, ul, ol, figure, li{
        padding: revert;
    }
    ul, li{
        list-style: revert;
    }
}
</style>
